import { nextTick } from 'vue';

const FOCUSABLE_SELECTORS =
  'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), details, [tabindex]:not([tabindex="-1"])';

const handleKeyDown = (event, firstElement, lastElement) => {
  if (event.key === 'Tab') {
    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }
};

const setupFocusTrap = (el, isActive) => {
  if (isActive) {
    nextTick(() => {
      // Save the last focused element on the background
      el.__lastFocusedElementOnBackground = el.__lastFocusedElementOnBackground || document.activeElement;

      // Ensure any previous listeners are removed
      cleanupFocusTrap(el);

      const focusableElements = el.querySelectorAll(FOCUSABLE_SELECTORS);
      let firstElement = focusableElements[0];
      let lastElement = focusableElements[focusableElements.length - 1];

      // Check if the last focused element exists and focus on it
      if (el.__lastFocusedElement && Array.from(focusableElements).includes(el.__lastFocusedElement)) {
        el.__lastFocusedElement.focus();
      } else if (firstElement) {
        firstElement.focus();
      }

      const handleKeyDownWrapper = (event) => {
        handleKeyDown(event, firstElement, lastElement);
      };

      // Save listeners and focus tracking
      el.addEventListener('keydown', handleKeyDownWrapper);
      el.addEventListener('focusin', (event) => {
        el.__lastFocusedElement = event.target; // Update the last focused element
      });

      // Save cleanup logic
      el.__focusTrapCleanup = () => {
        el.removeEventListener('keydown', handleKeyDownWrapper);
        el.removeEventListener('focusin', null);
        if (el.__lastFocusedElementOnBackground) {
          el.__lastFocusedElementOnBackground.focus();
        }
        el.__focusTrapCleanup = null; // Ensure cleanup logic is cleared
      };
    });
  } else {
    // Clean up focus trap if inactive
    cleanupFocusTrap(el);
  }
};

const cleanupFocusTrap = (el) => {
  if (el.__focusTrapCleanup) {
    el.__focusTrapCleanup();
  }
};

export default {
  mounted(el, binding) {
    console.log('focus mounted');
    setupFocusTrap(el, binding.value);
  },

  updated(el, binding) {
    console.log('focus updated');
    setupFocusTrap(el, binding.value);
  },

  unmounted(el) {
    cleanupFocusTrap(el);
  },
};
